import React, { Component, useState, useEffect } from 'react'
import Loader from '../Loader/Loader';
import Helper from '../Helper'
import useStateRef from 'react-usestateref';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { forgotPasswordMsgAction } from '../../middleware/forgotPasswordMsgAction';
import { MergeCartAction } from '../../middleware/MergeCartAction';
import { commerceItemDetailsAction } from '../../middleware/commerceItemDetailsAction';
import { updateProfileDetailsAction } from '../../middleware/updateProfileDetailsAction';
import { redirectUrlAction } from '../../middleware/redirectUrlAction';
import { Link } from 'react-router-dom';

export const CbLogin = ({ containerObject, templateName, contentId, dataZone }) => {
    const [pwd, setPwd] = useState('');
    const [isRevealPwd, setIsRevealPwd] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError, setHasErrorRef] = useStateRef(false);
    const [errorMessage, setErrorMessage, errorMessageRef] = useStateRef();
    const [guestLoginEnable, setGuestLoginEnable] = useState()
    const [urlParm, setUrlParm] = useState()
    const [searchUrl, setSearchUrl] = useState()
    const [searchParamUrl, setSearchParam, searchParamRef] = useStateRef("")
    const [mergeCart, setMergeCart, mergeCartRef] = useStateRef('')
    const history = useHistory();
    const dispatch = useDispatch();
    //from reducer state
    const successMessage = useSelector(state => state.forgotPasswordMsgReducer.message)
    const profile = useSelector(state => state.getProfileDetails.profileDetails)    

    const [loginResponse, setLoginResponse, loginResponseRef] = useStateRef();

    useEffect(() => {

        var url = history.location.pathname
        var splitedUri = url.split("/")
        setGuestLoginEnable(splitedUri[1])
        setUrlParm(splitedUri[1] + "/" + splitedUri[2])
        var searchParam = window.location.search
        setSearchParam(searchParam.split("=") ? searchParam.split("=")[1] : "")
        {
            successMessage && successMessage != null &&
                document.getElementById("forgot-success").classList.remove("d-none")
            document.getElementById("forgot-success").classList.add("d-block")
        }
    }, [history])



    //here we change the profile details based on the response
    useEffect(() => {
        if (profile) {
            setIsLoading(false)
            var response = loginResponseRef.current && loginResponseRef.current.response && JSON.parse(loginResponseRef.current.response).response;
            if (response) {
                if (response.mergeOrderFlag == true) {
                    history.push("/checkout/cart")
                } else if (searchParamRef.current && searchParamRef.current == 'list') {
                    history.push("/account/list")
                } else if (searchParamRef.current && searchParamRef.current == 'prev') {
                    history.goBack();
                } else if (urlParm && urlParm == "checkout/login") {
                    profile && profile.userType &&
                        profile.userType == 1 ? history.push("/checkout/cart") :
                        profile.userType == 2 ? history.push("/checkout/cart") :
                            profile.userType == 3 ? history.push("/checkout/int/save") : ""
                } else {
                    profile && profile.userType &&
                        profile.userType == 1 ? history.push("/account/b2c/landing") :
                        profile.userType == 2 ? history.push("/account/b2i/landing") :
                            profile.userType == 3 ? history.push("/account/b2c/landing") : ""
                }
            }
        }
    }, [profile])

    const goBack = () => {
        history.goBack();
    };


    const validateLoginForm = (key, value) => {
        switch (key) {
            case "username":
                var validation = "^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9-]+\\.)+[A-Za-z]{2,6}$";
                var regex = RegExp(validation);
                var result = Helper.isEmpty(value)
                if (result) {
                    setHasError(true)
                    document.getElementById("login-message-error-div").classList.remove("d-none")
                    document.getElementById("login-message-error-div").classList.add("d-block")
                    document.getElementById("userName").classList.add("form-error")
                    var emptylogin = document.getElementById("username_error-page")
                    emptylogin.innerHTML = "Email is a required field.";
                } else if (!regex.test(value)) {
                    setHasError(true)
                    document.getElementById("login-message-error-div").classList.remove("d-none")
                    document.getElementById("login-message-error-div").classList.add("d-block")
                    document.getElementById("userName").classList.add("form-error")
                    var emptylogin = document.getElementById("username_error-page")
                    emptylogin.innerHTML = "The email address does not appear to be valid. Please use the format name@domain.xxx.";
                } else {
                    var emptylogin = document.getElementById("username_error-page")
                    emptylogin.innerHTML = "";
                }
                break;
            case "password":
                var result = Helper.isEmpty(value)
                if (result) {
                    setHasError(true)
                    document.getElementById("login-message-error-div").classList.remove("d-none")
                    document.getElementById("login-message-error-div").classList.add("d-block")
                    document.getElementById("password-page").classList.add("form-error")
                    var emptypassword = document.getElementById("password_error")
                    emptypassword.innerHTML = "Password is a required field.";
                } else {
                    var emptypassword = document.getElementById("password_error")
                    emptypassword.innerHTML = "";
                }
                break;

            default:
        }
    }
    const handleRegister = (e) => {

        if (urlParm && urlParm == "checkout/login") {
            history.push("/checkout/register")
        } else {
            history.push("/account/register")
        }
    }
    const clearErrorMsg = (e) => {
        setErrorMessage("")
        document.getElementById("login-message-error").innerHTML = "";
        document.getElementById("login-message-error-div").classList.add("d-none");
        document.getElementById("userName").classList.remove("form-error")
        document.getElementById("password-page").classList.remove("form-error")

    }
    
    const handleForgotPassword = (e) => {
        if(searchParamRef.current && searchParamRef.current == 'prev'){
            history.push("/account/forgotPassword?resume=prev")
        }else{
            history.push("/account/forgotPassword")
        }
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        clearErrorMsg();
        setIsLoading(false)
        setHasError(false)
        var actionUrl = event.target.getAttribute('action');
        var formId = event.target.id;
        var formData = new FormData(event.target);
        const formValue = Object.fromEntries(formData.entries());

        Object.entries(formValue).map(([key, value], keyIndex) => {
            validateLoginForm(key, value)
        })
        var username = formData.get("username")
        var password = formData.get("password")
        const inputMap = {
            username: username,
            password: password
        }
        if (!setHasErrorRef.current) {

            // setIsLoading(true)
            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/${actionUrl}`, {
                method: 'POST',
                headers: new Headers({
                    "content-Type": "application/json",
                }),
                body: JSON.stringify(inputMap)
            }).then(res => res.json())
                .then(res => {
                    if (res.result === "success") {
                        setIsLoading(false)
                        const response = JSON.parse(res.response).response
                       dispatch(updateProfileDetailsAction(true,"login"))
                        setLoginResponse(res)
                        // if (profile) {
                        //     setIsLoading(false)

                        //     if (response.mergeOrderFlag == true) {
                        //         history.push("/checkout/cart")
                        //     } else if (searchParamRef.current && searchParamRef.current == 'list') {
                        //         console.log("proffile from list part ", profile);
                        //         window.location.href = "/account/list"
                        //     } else if (searchParamRef.current && searchParamRef.current == 'prev') {
                        //         console.log("proffile from prev part ", profile);
                        //         history.goBack();
                        //     } else if (urlParm && urlParm == "checkout/login") {
                        //         console.log("proffile from elseif part ", profile);
                        //         profile && profile.userType &&
                        //             profile.userType == 1 ? window.location.href = "/checkout/cart" :
                        //             profile.userType == 2 ? window.location.href = "/checkout/cart" :
                        //                 profile.userType == 3 ? window.location.href = "/checkout/int/save" : ""
                        //     } else {
                        //         console.log("proffile from else part ", profile);
                        //         profile && profile.userType &&
                        //             profile.userType == 1 ? window.location.href = "/account/b2c/landing" :
                        //             profile.userType == 2 ? window.location.href = "/account/b2i/landing" :
                        //                 profile.userType == 3 ? window.location.href = "/account/b2c/landing" : ""
                        //     }
                        // } else {
                        //     setIsLoading(false)
                        //     const error = res._ERROR_MESSAGE_;
                        //     setErrorMessage(error);
                        //     document.getElementById("login-message-error-div").classList.remove("d-none");
                        // }
                    } else {
                        setIsLoading(false)
                        const error = JSON.parse(res._ERROR_MESSAGE_).message;
                        setErrorMessage(error);
                        document.getElementById("login-message-error-div").classList.remove("d-none");
                        document.getElementById("login-message-error-div").classList.add("d-block");
                    }
                })
        }
    }

    return (<>
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-shop-list-detail`} >
            <div className='row justify-content-center'>
                <div class="col-12 col-md-8 mx-auto mt-md-4 mt-3">
                    <div id="login-message-success-div" className="d-none alert alert-success">
                        <div id="login-message-success"></div>
                    </div>

                    <div id="forgot-success" class="alert alert-warning mb-3 d-none" >
                        <p class="black-color">
                            {successMessage}
                        </p>
                    </div>


                    <div id="login-message-error-div" className="d-none alert alert-danger login-error-msg">

                        {/* <div id="login-message-error" dangerouslySetInnerHTML={{ __html: errorMessageRef.current }}></div> */}
                        <div id="login-message-error" dangerouslySetInnerHTML={{ __html: errorMessageRef.current }}></div>

                        <div id="username_error-page"></div>
                        <div id="password_error"></div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-4 mb-md-5 mx-auto mt-3 mt-md-0">
                <div className={`vast-plugin-content login-content row g-0 mb-2 mt-2`}>
                    {isLoading ? <Loader /> : ""}
                    <div class="text-left mb-2 c-back-link text-left" onClick={goBack} style={{ cursor: 'pointer' }}>&lt;&nbsp; back to previous page</div>
                    <div class="c-account-wrapper">
                        <div class="text-left mt-3 mb-3">
                            <h1 class="c-account-heading">
                                Sign in to Your Account
                            </h1>
                        </div>
                        <form method="post" action="login" id="customLogin" class="row g-3 c-account-page" onSubmit={handleSubmit}>
                            <div class="col-md-12">
                                <label for="inputEmail4" class="form-label">Email</label>
                                <input maxlength="256" name="username" id="userName" type="" className="form-control" />
                            </div>
                            <div class="col-md-12 c-show-password" style={{ position: 'relative' }}>
                                <label for="inputPassword" class="form-label">Password</label>
                                <input name="password" id="password-page" type={isRevealPwd ? "text" : "password"} className="form-control" value={pwd} onChange={e => setPwd(e.target.value)} />
                                <Link class="c-login-show" style={{ position: 'absolute' }} id="show-password" onClick={() => setIsRevealPwd(prevState => !prevState)}>
                                    {isRevealPwd ? 'HIDE' : 'SHOW'}
                                </Link>
                            </div>
                            <div class="col-12 d-grid">
                                <button type="submit" class="btn btn-primary block" id="signin-button">Sign In</button>
                            </div>
                        </form>
                        <div class="col-12 ml-auto mt-4 mb-4">
                            <Link class="c-back-link text-left" onClick={handleForgotPassword}>
                                Forgot Password?
                            </Link>
                        </div>
                        <hr />
                        <div class="text-left d-lg-block d-md-none d-none mt-2">
                            <p class="text-left c-regular-text m-hidden">New to Carolina.com?</p>
                        </div>
                        <Link onClick={handleRegister} class="register-link col-12 d-grid mt-0 mb-3" style={{ textDecoration: "none" }}>
                            <button type="submit" class="btn btn-secondary block">Register New Account</button>
                        </Link>
                        {guestLoginEnable && guestLoginEnable == "checkout" ?
                            <div class="blue-text blue-link font-weight-bold text-center">
                                <Link class="underline brightBlue font-size-13" to="/checkout/shipping">
                                    Continue as Guest
                                </Link>
                            </div> : ""}
                    </div>
                </div>
            </div>
        </div>
    </>
    )
}
